<template>
  <div class="px-3">{{ date }} | {{ time }}</div>
</template>

<script>
import persianDate from "persian-date/dist/persian-date";

export default {
  name: "DateAndTime",
  data() {
    return {
      time: "",
      date: "",
    };
  },
  created() {
    this.updateDate()
  },
  methods: {
    updateDate() {
      setInterval(() => {
        const timeAndDate = new persianDate();
        this.time = timeAndDate.toLocale("fa").format("L");
        this.date = timeAndDate.toLocale("fa").format("HH:mm");
      }, 1000);
    },
  },
};
</script>

<style scoped>
div {
  background-color: #B9E1DA !important;
  font-family: "DanaFaNum";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 29px;
  display: flex;
  align-items: center;
  color: #329988;
}
</style>